export const LOAD_ALL_CURRENCIES = 'LOAD_ALL_CURRENCIES'
export const LOAD_ALL_APP_CURRENCIES = 'LOAD_ALL_APP_CURRENCIES'
export const LOAD_DEFAULT_CURRENCY = 'LOAD_DEFAULT_CURRENCY'
export const LOAD_CURRENCIES = 'LOAD_CURRENCIES'
export const ADD_CURRENCY = 'ADD_CURRENCY'
